export default {
    functional: true,

    props:
    {
        item: Object,
    },

    render(h, { data, props, listeners })
    {
        return h(
            'div',

            {
                staticClass: data.staticClass,

                class: [
                    'vh-badge',
                    'vh-badge-primary',
                    'vh-flex-middle',
                    'vh-badge-margin-small-top',
                ],
            },

            [
                h(
                    'div',

                    [
                        h(
                            'i',
                            {
                                class: [
                                    `fa ${props.item.icon}`,
                                    'vh-margin-xsmall-right',
                                ]
                            }
                        ),
                        props.item.value,
                    ],
                ),

                h(
                    'div',
                    {
                        class: 'vh-margin-small-left',
                    },

                    [
                        h(
                            'a',
                            {
                                class: 'vh-point',
                            },
                            [
                                h(
                                    'i',
                                    {
                                        class: 'fa fa-times',

                                        on:
                                        {
                                            click: listeners.reset
                                        },
                                    },
                                ),
                            ]
                        ),
                    ]
                ),
            ]
        );
    },
};



// WEBPACK FOOTER //
// ./src/components/badge/vh-badge.js